import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {EntitiesRecognizerRepository} from "./entities-recognizer.repository";
import {EntitiesRecognizerFactory} from "./entities-recognizer.factory";

export class EntitiesRecognizerDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, EntitiesRecognizerRepository, EntitiesRecognizerFactory, DomainRequestManager];
}
